module.exports = {"updown_read_key":"ro-VsbzgyyyCuNsDBi5vbHK","twitter":"evosesports","website_name":"ATTN","website_url":"http://attn.sg","logo_url":"https://www.evos.gg/images/pages/Oon92liTCVWOj7IUe5LFjSUiiD2UpDaHAma8bPUa.png"}


//////////////////
// WEBPACK FOOTER
// ./page_config.json
// module id = Yr1l
// module chunks = 1